import { Button, Tooltip } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import CalendarIssues from "components/CalendarIssues";
import { useState } from "react";
import dayjs from "dayjs";

const IssueCalendar = ({
  worker_id,
  issue_id,
  disabled,
  origin_source,
  show_calendar_icon = false,
  handleConfirm,
  tooltip,
}) => {
  const [calendar_date, setDayCalendarDate] = useState(null);
  return (
    <>
      <CalendarIssues
        origin_source={origin_source}
        worker_id={worker_id}
        issue_id={issue_id}
        date={calendar_date}
        handleClose={() => setDayCalendarDate(null)}
        handleConfirm={(date) => {
          handleConfirm?.(date);
        }}
      />
      {tooltip ? (
        <Tooltip title={tooltip}>
          <Button
            disabled={disabled}
            type="primary"
            block={!show_calendar_icon}
            htmlType="button"
            icon={show_calendar_icon ? <CalendarOutlined /> : null}
            onClick={() => setDayCalendarDate(dayjs())}
          >
            {show_calendar_icon ? null : "Kalendarz"}
          </Button>
        </Tooltip>
      ) : (
        <Button
          disabled={disabled}
          type="primary"
          block={!show_calendar_icon}
          htmlType="button"
          icon={show_calendar_icon ? <CalendarOutlined /> : null}
          onClick={() => setDayCalendarDate(dayjs())}
        >
          {show_calendar_icon ? null : "Kalendarz"}
        </Button>
      )}
    </>
  );
};

export default IssueCalendar;
